import { FlexView } from '@components/Common';

export default () => <FlexView center fixed />;
